import Firebase from 'firebase';

const app = Firebase.initializeApp(process.env.firebase);

app.auth().setPersistence(Firebase.auth.Auth.Persistence.SESSION);
const auth = app.auth();
const googleProvider = new Firebase.auth.GoogleAuthProvider();
googleProvider.addScope('https://www.google.com/m8/feeds');

const db = app.database();
//
// auth.onAuthStateChanged((data) => {
//   console.log('onAuthStateChanged', data);
//   console.log(auth.currentUser);
// });
//
// auth.onIdTokenChanged((data) => {
//   console.log('onIdTokenChanged', data);
// });

export {
  app as default,
  auth,
  db,
  googleProvider,
};



// WEBPACK FOOTER //
// ./src/firebase/index.js